<template>
    <header class="header" v-if="setup != null" id="header">
        <div class="container">
            <div class="header-container">
                <!-- <navMain class="header-navigation newyear-2021"></navMain> -->
                <div class="col-left">
                    <div class="column-inner-content">
                        <div class="logo-bazis">
                            <router-link to="/" @click.native="startLoader">
                                <img :src="setup.logo_bazis.img" alt="sales.bazis.kz BAZIS-A">
                                <img :src="setup.logo_bazis.img_mobile" alt="sales.bazis.kz BAZIS-A" class="mobile-logo">
                            </router-link>
                        </div>

                        <div class="user-links user-links-mobile ny-theme" v-if="isMobileChecker">
                            <div class="item">
                                <a :href="URLrocketLC + '/?lang=' + globalLang" @click.prevent="linkToCabinet" target="_blank">
                                    <svgIcon name="login-new" class="icon-user"/>
                                </a>
                            </div>
                            <div class="item" @click="$store.commit('setOpenPhonesCityMobile', !openPhonesCity)" v-click-outside="closePhonesCityWindow">
                                <a href="#" class="get-form" @click.prevent>
                                    <svgIcon name="phone-header" class="icon-phone"/>
                                </a>
                                <div class="phone-city-items" v-if="phoneCityItems != null" :class="{'open' : openPhonesCity}">
                                    <div class="item-phone" v-for="(item, index) in phoneCityItems" :key="index">
                                        <span>г. {{ item.region }}</span>
                                        <a :href="'tel:' + item.region_phone">{{ item.region_phone }}</a>
                                    </div>
                                </div>
                            </div>
                            <div class="item">
                                <router-link :to="{ name : 'favorite-page' }" :class="{'active' : countFavorite > 0}" @click.native="startLoader">
                                    <svgIcon name="favorite" class="icon-star"/>
                                </router-link>
                            </div>
                            <div class="item">
                                <router-link :to="{ name : 'compare' }" @click.native="startLoader">
                                    <svgIcon name="ab" class="icon-ab"/>
                                </router-link>
                            </div>
                        </div>

                        <div class="mobile-menu" :class="{open: openSendwich}" @click="openMobileMenu(!openSendwich)">
                            <span></span>
                        </div>

                        <div class="btn-online" v-if="!isMobileChecker">
                            <router-link to="/flats" @click.native="forMetrika()" :class="{'animate-btn': animateOnlineBtn}">
                                <svgIcon name="mouse-header" class="icon-mouse"/>
                                <span>{{setup.header_btn_online}}</span>
                                <!-- <span>{{setup.sales_setup_new.header_btn_online}}</span> -->
                            </router-link>
                        </div>

                        <div class="header-mini-nav" v-if="!isMobileChecker">
                            <miniNavMain></miniNavMain>
                        </div>
                    </div>
                        
                </div>
                <div class="col-right" v-if="!isMobileChecker">

                    <div class="user-links">
                        <div class="item">
                            <a :href="URLrocketLC + '/?lang=' + globalLang" @click.prevent="linkToCabinet" target="_blank">
                                <svgIcon name="login-new" class="icon-user"/>
                            </a>
                        </div>
                        <div class="item">
                            <a href="#" class="get-form" @click.prevent>
                                <svgIcon name="phone-new" class="icon-phone"/>
                            </a>
                            <div class="phone-city-items" v-if="phoneCityItems != null" :class="{'open' : openPhonesCity}">
                                <div class="item-phone" v-for="(item, index) in phoneCityItems" :key="index">
                                    <span>г. {{ item.region }}</span>
                                    <a :href="'tel:' + item.region_phone">{{ item.region_phone }}</a>
                                </div>
                            </div>
                        </div>
                        <div class="item">
                            <router-link :to="{ name : 'favorite-page' }" :class="{'active' : countFavorite > 0}" @click.native="startLoader">
                                <svgIcon name="favorite" class="icon-star"/>
                            </router-link>
                        </div>
                        <div class="item">
                            <router-link :to="{ name : 'compare' }" @click.native="startLoader">
                                <svgIcon name="ab" class="icon-ab"/>
                            </router-link>
                        </div>
                    </div>

                    <div class="lang-selector">
                        <div class="current-lang" @click="langOpen = !langOpen" :class="{'open': langOpen}">
                            <div v-if="globalLang == ''">Рус <span></span></div>
                            <div v-if="globalLang == 'kz/'">Қаз <span></span></div>
                            <div v-if="globalLang == 'en/'">Eng <span></span></div>
                            <!-- <div v-if="globalLang == 'en/'">Еng <span></span></div> -->
                        </div>
                        <div class="dropdown-lang" :class="{'open': langOpen}">
                            <ul>
                                <li v-if="globalLang != ''"><a href="#" @click.prevent="setLocale('')">Рус</a></li>
                                <li v-if="globalLang != 'kz/'"><a href="#" @click.prevent="setLocale('kz/')">Қаз</a></li>
                                <li v-if="globalLang != 'en/'"><a href="#" @click.prevent="setLocale('en/')">Eng</a></li>
                                <!-- <li v-if="globalLang != 'en/'"><a href="#" @click.prevent="setLocale('en/')">Еng</a></li> -->
                            </ul>
                        </div>
                    </div>

                </div>
                
            </div>
        </div>
    </header>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';

    import miniNavMain from '@/components/nav-main/mini-nav-main.vue'
    export default {
        name: 'AppHeader',
        components: {
            svgIcon,
            miniNavMain,
            // navMain,
        },
        data () {
            return {
                iSmobile: false,
                langOpen: false,
                globalLang: window.GlobalLang, 
                phoneCityItems: null,
                animateOnlineBtn: true,
            }
        },
        computed: mapGetters({
            setup: 'loadPageSetUp',
            countFavorite: 'loadFavoriteCount',
            openSendwich: 'loadOpenSendwich',
            openPhonesCity: 'loadPhonesCityOpen',
            URLrocketLC: 'loadUrlRocketLC',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            startAnimationCycle() {
                // console.log('work')
                setTimeout(() => {
                    this.animateOnlineBtn = false;
                }, 10000);
                setInterval(() => {
                    this.animateOnlineBtn = true;
                    setTimeout(() => {
                        this.animateOnlineBtn = false;
                    }, 10000); // Убираем класс через 10 секунд
                }, 30000); // Добавляем класс раз в минуту
            },
            forMetrika() {
                ym(57579163,'reachGoal','btn_online')
            },
            setLocale(lang) {
                localStorage.setItem('language', lang);
                document.location.reload(true);
            },
            getCityPhones() {
                var data = this.setup.regions_name;
                var filteredItems = data.filter(item => {
                    return item.region == 'Алматы' ||
                            item.region == 'Астана' ||
                            item.region == 'Шымкент' 
                });
                this.phoneCityItems = filteredItems;
                // console.log(this.phoneCityItems)
            },
            // setCurrentCity(city) {
            //     this.dropdownCity = !this.dropdownCity;
            //     this.$store.commit('CurrentCity', city);
            //     localStorage.setItem('regionCity', city);
            //     this.filterRegion(city);
            //     this.regionCity = city;
            //     document.location.reload(true);
            // },
           
            // filterRegion(city) {
            //     var data = this.setup.regions_name;
            //     var filteredItems = data.filter(item => {
            //         return item.region_lat.slug === city
            //     })
            //     // console.log(filteredItems)
            //     this.$store.commit('CurrentCityArr', filteredItems);
            //     // this.regionCityArr = filteredItems;
            // },
            openMobileMenu(data) {
                this.$store.commit('Open_Sendwich', data);
                this.$store.commit('Open_form_Consult', false);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
            },
            startLoader() {
                this.$parent.$refs.topProgress.start();
            },
            linkToCabinet() {
                // console.log(this.window.rockeLC, 'asdsadasda')
                var exist = localStorage.getItem('favorite_flats');
                exist = exist ? exist.split(',') : [];
                var url = this.URLrocketLC + '/?lang=' + this.langVAR;
                var favoriteUrl;
                if (exist.length > 0) {
                    favoriteUrl = '&favoritesFlats=' + exist.join(',');
                    console.log(exist, favoriteUrl);
                    window.open(
                        url + favoriteUrl,
                        '_blank'
                    );
                } else {
                    window.open(
                        url,
                        '_blank'
                    );
                }
            },
            closePhonesCityWindow() {
                // console.log('click outside')
                this.$store.commit('setOpenPhonesCityMobile', false);
            },
            // MOBILE CHECKER
            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                }
            },
            handleResize() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                } else {
                    this.iSmobile = false
                }
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
            this.getCityPhones();
            this.startAnimationCycle();
            // this.isMobileCheck();
            // this.checkResize();
            // this.$store.watch(
            //     (state) => state.pageSetup,
            //     (newValue) => {
            //         if (newValue != null) {
            //             this.setCockieStorage();
            //         }
            //     }
            // )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/header/header.scss';
    @import '@/styles/respond/header/respond-header.scss';
</style>